module.exports = __webpack_public_path__ + "static/media/psd.ba87fb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/psd.png
// module id = 2569
// module chunks = 0